import React from 'react';
import Card from 'react-bootstrap/Card';
import { Container } from 'react-bootstrap';
import PollsGroupDetailCard from '../PollsGroupDetailCard/PollsGroupDetailCard';
import PollsResults from '../PollsResults/PollsResults';

const PollsGroupClassDetails = groupClassDetailsProps => {
  const { appoitmentVstTypName, polls } = groupClassDetailsProps;

  return (
    <Container className="vve-group-class-table-polls">
      <Card>
        <Card.Header className="vve-text-bold">{appoitmentVstTypName}</Card.Header>
        <Card.Body>
          <PollsGroupDetailCard {...groupClassDetailsProps} />
          <hr className="vve-divider vve-divider-top" />
          <hr className="vve-divider vve-divider-bottom" />
          <Card.Text>
            <PollsResults polls={polls} />
          </Card.Text>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PollsGroupClassDetails;
